import { DraggableComponent } from '../../draggable/draggable.component';

export class DragDropPositionService {
  static calculateZeroPosition(
    draggableComponents: Array<DraggableComponent>,
    htmlIndex: number,
    isHorizontal = false,
  ) {
    return draggableComponents
      .filter((component, index) => index < htmlIndex)
      .reduce((currentNumber, component) => {
        return (
          currentNumber - (isHorizontal ? component.width : component.height)
        );
      }, 0);
  }

  static calculatePositionByIndex(
    draggableComponents: Array<DraggableComponent>,
    index: number,
    gutterSize: number,
    collapse: boolean,
    draggingOutside: boolean,
    checkCollapse = true,
    includeGutter = true,
    whiteSpaceIndex = -1,
    whiteSpaceSize = 0,
    isHorizontal = false,
  ) {
    return draggableComponents
      .filter((component) => component.index < index)
      .filter((component) => {
        if (
          checkCollapse &&
          component.dragging &&
          collapse &&
          draggingOutside
        ) {
          return false;
        }

        return true;
      })
      .reduce(
        (currentNumber, component) => {
          const size = isHorizontal ? component.width : component.height;
          if (includeGutter) {
            return currentNumber + size + gutterSize;
          }
          return currentNumber + size;
        },
        index >= whiteSpaceIndex ? whiteSpaceSize : 0,
      );
  }
}
